module.exports = __webpack_public_path__ + "img/p7.b355b2c9.png";